import { api } from '@forbiz/web-kit'
import type {
  CompanyPartnerListResponse,
  CompanyPartnerResponse,
  CreateCompanyPartnerRequest,
  UpdateCompanyPartnerRequest,
} from '@forbiz/contracts'

/**
 * 거래처 API 클라이언트 (BIZ-49).
 * 조회·선택은 담당자도, 등록·수정·삭제는 기업 관리자만(서버가 최종 판정).
 */
export const companyPartnersApi = {
  list: () => api.get<CompanyPartnerListResponse>('/api/company-partners'),
  create: (body: CreateCompanyPartnerRequest) =>
    api.post<{ partner: CompanyPartnerResponse }>('/api/company-partners', body),
  update: (id: number, body: UpdateCompanyPartnerRequest) =>
    api.put<{ partner: CompanyPartnerResponse }>(`/api/company-partners/${id}`, body),
  remove: (id: number) => api.del<{ ok: true }>(`/api/company-partners/${id}`),
}
